import * as React from "react";
import Amplify, { Auth } from "aws-amplify";
import { IAuthInterface } from "../../services/interfaces/IAuthInterface";
import ConfigService from 'src/services/config/config.service';

Amplify.configure({
	Auth: {
		userPoolId: ConfigService.getConfig().awsConfig.cognitoUserPoolId,
		region: ConfigService.getConfig().awsConfig.cognitoRegion,
		userPoolWebClientId: ConfigService.getConfig().awsConfig.userPoolWebClientId,
		identityPoolId: ConfigService.getConfig().awsConfig.userPoolIdentityPoolId,
		identityId: ConfigService.getConfig().awsConfig.userPoolIdentityId
	}
});

export const DefaultAuthContextState: IAuthInterface = {
  signUp: async (email: string, password: string) => {
    const lowerCaseEmail = email.toLowerCase();
    return Auth.signUp({
      password,
      username: lowerCaseEmail,
      attributes: {
        email: lowerCaseEmail
      }
    });
  },
  confirmSignUp: async (email: string, code: string) => {
    return new Promise<any>(async (res, reject) => {
      try {
        res(await Auth.confirmSignUp(email.toLowerCase(), code));
      } catch (e) {
        if (e.code === "UnexpectedLambdaException" || e.code === "NotAuthorizedException") {
          res(true);
        } else {
          reject(e);
        }
      }
    });
  },
  signIn: async (email: string, password: string) => {
    return Auth.signIn(email.toLowerCase(), password);
  },
  signOut: async () => {
    return Auth.signOut();
  },
  requestEmailConfirmation: async (email: string) => {
    return Auth.resendSignUp(email.toLowerCase());
  },
  forgotPassword: async (email: string) => {
    return Auth.forgotPassword(email);
  },
  forgotPasswordSubmit: async (email: string, code: string, newPassword: string) => {
    return Auth.forgotPasswordSubmit(email, code, newPassword);
  },
  signInOfficer: async () => {
    return null;
  },
  completeNewPassword: async (user: any, newPass: string) => {
    return null;
  },

  isLoggedIn: () => false,

  isOfficer: () => false,

  isAdministrator: () => false,
  isClient: () => false,

  currentEmail: undefined,
  currentUser: undefined
};

export const AuthContext = React.createContext<IAuthInterface>(DefaultAuthContextState);



// WEBPACK FOOTER //
// ./src/components/context/AuthContext.ts